import axios from "axios";
import { getHomeLinksByCountry } from "./GetHomeLinksByCountryAction";
import {
  deleteHomeLinkRequested,
  deleteHomeLinkRequestSucceeded,
  deleteHomeLinkRequestFailed,
} from "../slices/DeleteHomeLinkSlice";

const apiUrl = `${process.env.REACT_APP_BASE_API_URL}/api/Home/DeleteHomeLink`;
const ApiKey = process.env.REACT_APP_BASE_API_KEY;

export const DeleteHomeLink = (id) => async (dispatch) => {
  try {
    dispatch(deleteHomeLinkRequested());

    const axiosConfig = {
      headers: {
        ApiKey: ApiKey,
        "Content-Type": "application/json",
      },
    };

    const response = await axios.delete(`${apiUrl}?id=${Number(id)}`, axiosConfig);

    if (response.data === true) {
      dispatch(deleteHomeLinkRequestSucceeded(response.data));
      await dispatch(getHomeLinksByCountry());
      return { success: true, message: "Home link deleted successfully" };
    }

    const errorMessage = "The home link could not be deleted. It may not exist.";
    dispatch(deleteHomeLinkRequestFailed(errorMessage));

    return { success: false, message: errorMessage };
  } catch (error) {
    const errorMessage = error.response?.data || error.message;
    dispatch(deleteHomeLinkRequestFailed(errorMessage));

    return {
      success: false,
      message: errorMessage,
    };
  }
};
